import { Modal, ModalProps } from '@salecycle/ui-component-library';
import { CampaignNameInput } from '@salecycle/experimental/CampaignNameInput';
import { useCreateCampaignState } from './hooks/useCreateCampaignState';
import { useCreateCampaign } from './hooks/useCreateCampaign';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CreateCampaignModalProps extends ModalProps {}

export const CreateCampaignModal = ({ ...props }: CreateCampaignModalProps) => {
  const { t } = useTranslation('campaigns');
  const { state, setName } = useCreateCampaignState();
  const { createCampaign } = useCreateCampaign(state);

  return (
    <Modal
      {...props}
      heading={t('bulkRetargetingCampaigns.createModal.heading')}
      minWidth={600}
      variation="clean"
      okButtonLabel={t('bulkRetargetingCampaigns.createModal.okButtonLabel')}
      onOkButtonClicked={createCampaign}
      okButtonDisabled={!state.isValid}
      okButtonDisabledTooltip={!state.isValid && t('bulkRetargetingCampaigns.createModal.okButtonDisabledTooltip')}
    >
      <CampaignNameInput
        name={state.name}
        setName={setName}
        aria-label={t('bulkRetargetingCampaigns.createModal.campaignNameAria')}
        placeholder={t('bulkRetargetingCampaigns.createModal.campaignNamePlaceholder')}
        validationMessage={{ warning: t('bulkRetargetingCampaigns.createModal.campaignNameValidationMessage') }}
      />
    </Modal>
  );
};
